export const VSCODE_SETTINGS: Record<string, unknown> = {
  'files.autoSave': 'off',
  'extensions.autoUpdate': false,
  'extensions.autoCheckUpdates': false,
  'editor.quickSuggestions': {
    other: 'on',
    comments: 'off',
    strings: 'on',
  },
};
